/**
 * Replaces newlines with `<br>` tags.
 *
 * @param {*} str
 * @returns {string}
 */
export default function nl2br(str) {
    if (!str) {
        return '';
    }

    return String(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
}
